/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useDownMedia } from './useDownMedia';

export const useIsTablet = () => useDownMedia('md');
